import script from "./BadWordListModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./BadWordListModal.vue?vue&type=script&setup=true&lang=ts"

import "./BadWordListModal.vue?vue&type=style&index=0&id=500cedde&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-500cedde"]])

export default __exports__